import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { ref } from '@dbk-legacy/muster/utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { pure } from '@dbk/ui-react-utils';
import { FormattedMessage } from '@dbk/format';
import { Tab, Tabs } from '@dbk/ui-tabs';
import SortingHeader from '../../../components/common/sorting-header';
import styles from './header-tabs.styles';


function HeaderTabs({ maturities, resetSort, messages, dateRangeFn }) {
  const {
    tabs,
    selectedTabIndex,
    setSelectedTabIndex,
    openCalendar,
  } = maturities;

  const handleTabChange = i => {
    const tab = tabs[i];
    if (tab.periodType !== 'custom') {
      resetSort();
      dateRangeFn.setShowDateRange(false);
    } else dateRangeFn.setShowDateRange(true);
    setSelectedTabIndex(i);
  }

  return (
    <View id="tab_maturities_headerTabs_test" style={styles.root}>
      <Tabs
        stretch
        secondary
        handleSelectedIndex={handleTabChange}
        selectedIndex={selectedTabIndex}
      >
        {
          tabs.map((tab, i) => <Tab testID={"tab_maturities_inner_headerTabs_test_"+i} secondary renderLabel={() => <FormattedMessage
            id={`app.maturities.overview.tabs.labels.${tab.periodType}`}
            values={{ n: tab.periodNo }}
          />} />)
        }
      </Tabs>

      <SortingHeader
        enabled={false}
        showBorder={false}
        messages={messages}
      />
    </View>
  );
}

HeaderTabs.propTypes = {
  maturities: PropTypes.shape({
    tabs: PropTypes.arrayOf(PropTypes.shape({
      periodType: PropTypes.string,
      periodNo: PropTypes.number,
      fromDate: PropTypes.date,
      toDate: PropTypes.date,
    })),
  }),
  resetSort: PropTypes.func,
};

export default createContainer({
  $fragments: {
    maturities: {
      tabs: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('maturities.tabs.length'),
        },
        $node: {
          periodType: true,
          periodNo: true,
          fromDate: true,
          toDate: true,
        },
      },
      selectedTabIndex: true,
      setSelectedTabIndex: { $set: 'selectedTabIndex' },
      openCalendar: { $call: 'calendar.open' },
    },
  },

})(pure(HeaderTabs));
